import { FileOrDir } from '@common_components/inputs/sendFileInput.component';
import JSZip from 'jszip';


export async function buildCloudUploadFormData( files: FileOrDir[] ): Promise<FormData> {

  const formData = new FormData();

  const filesToZip = files
    .filter( file => { return file.isFile; } )
    .map( file => { return file.file; } );

  const foldersToUnZip = files
    .filter( file => { return file.isDirectory; } )
    .map( file => { return file.file; } );

  if ( filesToZip.length === 1 && foldersToUnZip.length === 0 ) {
    formData.append( 'content', filesToZip[ 0 ] );
    formData.append( 'type', 'file' );

    return formData;
  }

  const zip = new JSZip();
  for ( const file of filesToZip ) {
    const relativePath = file.webkitRelativePath || file.name;
    zip.file( relativePath, file );
  }
  for ( const folder of foldersToUnZip ) {
    await zip.loadAsync( folder );
  }

  const blob = await zip.generateAsync( {
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: {
      level: 6,
    },
  } );

  const zipFile = new File(
    [ blob ],
    'export_cloud.zip',
    {
      type: 'application/zip',
    }
  );

  formData.append( 'content', zipFile );
  formData.append( 'type', 'directory' );

  return formData;
}